import styled from "styled-components"

export default styled.span`
    display: inline-block;
    width: 5px;
    height: 5px;
    margin: 2px 2px;
    background: #9F9F9F;
    border-radius: 50%;
`;